import type React from "react";

import styled from "styled-components";

import type { DropdownContentProps } from "app/pages/workspace/sales/components/custom-dropdown/DropdownContent/DropdownContent";
import { StyledDropdownContent } from "app/pages/workspace/sales/components/custom-dropdown/DropdownContent/styles";

export const StyledDropdownBody = styled<React.FC<DropdownContentProps & { isDropdownLeft: boolean }>>(
    StyledDropdownContent,
)`
    display: flex;
    flex-direction: column;
    left: ${(props) => (props.isDropdownLeft ? 0 : "unset")};
    right: ${(props) => (props.isDropdownLeft ? "unset" : 0)};
    top: 40px;
    width: 332px;
`;
